import './onsitestep.less'

import requestService from 'mithril/request/request'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import {ConfirmationData} from 'models/registration/steps/SummaryStepModel'
import React, {useState} from 'react'
import {useHistory} from 'react-router'
import {Mod} from 'types'
import {style} from 'util/style'
import {PopupModal} from 'views/layout/popupmodal'
import {Step} from 'views/registration/step'
import {Theme} from 'views/theme'

const request = requestService(window, Promise).request

const styles = style('onsitestep', ['info'])

export const OnsiteStep: React.FC<{
	registration: RegistrationModel
	updateRegistration: (model: RegistrationModel) => void
}> = attrs => {
	const {registration, updateRegistration} = attrs
	const [submitting, setSubmitting] = useState(false)
	const [open, setOpen] = useState(true)
	const step = registration.allSteps.onsite
	const confirmation = registration.confirmation
	const history = useHistory()

	return (
		<form
			onSubmit={e => {
				e.preventDefault()
				setSubmitting(true)
				request({
					method: 'POST',
					url: `/api/register/confirm/${confirmation.token}`
				})
					.then(response => {
						setSubmitting(false)
						window.sessionStorage.removeItem(`registration_${registration.id}`)
						history.push('#badge')
					})
					.catch(error => {
						setSubmitting(false)
					})
				return false
			}}
		>
			<Step step={step} hasFormSubmit={true}>
				<PopupModal open={open} onClose={() => setOpen(false)}>
					<PopupModal.Block>
						<PopupModal.Content mod="big">
							<Theme.H1 as="h2" mod={['dots']}>
								{step.config.popup_title}
							</Theme.H1>
							<PopupModal.Message>
								<Theme.Wysiwyg>{step.config.popup_message}</Theme.Wysiwyg>
							</PopupModal.Message>
						</PopupModal.Content>
						<PopupModal.Footer />
					</PopupModal.Block>
				</PopupModal>
				<OnsiteStepInfo registration={registration} />
			</Step>
		</form>
	)
}

export const OnsiteStepInfo: React.FC<{
	registration: RegistrationModel
	mod?: Mod<'done'>
}> = ({registration, mod}) => {
	const confirmation = registration.confirmation
	const method = registration.allSteps.summary.methods.find(
		method => method.key === registration.state.summary.payment_option
	)

	return (
		<div {...styles.info.mod(mod)}>
			<p>
				<b>Name:</b> {registration.state.details.firstname}{' '}
				{registration.state.details.lastname}
			</p>
			<p>
				<b>Company:</b> {registration.state.details.company}
			</p>
			<p>
				<b>Amount due:</b> € {confirmation.price.incl}
			</p>
			<p>
				<b>Payment method:</b> {method?.label}
			</p>
		</div>
	)
}
